import * as React from "react";

import { IconCog } from "../icons/IconCog";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonCog: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonCog.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconCog />
        </MprcIconButton>
    );
};
